"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterPropertiesCache = void 0;
var tslib_1 = require("tslib");
var character_properties_1 = require("../../character/character-properties");
var font_info_1 = require("../../fonts/font-info");
var hash_based_cache_1 = require("../hash-based-cache");
var CharacterPropertiesCache = (function (_super) {
    tslib_1.__extends(CharacterPropertiesCache, _super);
    function CharacterPropertiesCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CharacterPropertiesCache.getRareCharProperty = function (fontMeasurer) {
        if (!CharacterPropertiesCache._rareCharProperty) {
            var prop = new character_properties_1.CharacterProperties();
            prop.fontInfo = new font_info_1.FontInfo("Calibri");
            prop.fontInfo.measurer = fontMeasurer;
            prop.fontSize = 200;
            CharacterPropertiesCache._rareCharProperty = prop;
        }
        return CharacterPropertiesCache._rareCharProperty;
    };
    CharacterPropertiesCache.prototype.resetSizes = function () {
        this.forEach(function (prop) {
            prop.clearSizes();
            if (prop.fontInfo)
                prop.fontInfo.reset();
        });
    };
    CharacterPropertiesCache.prototype.copyFrom = function (obj) {
        _super.prototype.copyFrom.call(this, obj);
    };
    CharacterPropertiesCache.prototype.clone = function () {
        var result = new CharacterPropertiesCache();
        result.copyFrom(this);
        return result;
    };
    return CharacterPropertiesCache;
}(hash_based_cache_1.HashBasedCache));
exports.CharacterPropertiesCache = CharacterPropertiesCache;
